import { useModalMeta } from "@/shared/atoms/useModal";
import useBranchId from "@/shared/hooks/useBranchId";
import { IMAGE_LIBRARY_TYPE } from "@/shared/imageLibrary/types";
import { getFieldByLang, getMenuImageUrl } from "@/shared/utils/helpers";
import { Product } from "@/shared/utils/interfaces";
import { useTranslation } from "react-i18next";
import { ModalProps } from "../../Modal/Modal";
import { PRODUCT_IMAGE_GUIDELINES } from "../UploadImageWithLibrary/imageGuidelines";
import UploadImageWithLibraryModal from "../UploadImageWithLibraryModal";
import useProductImageSave from "./useProductImageSave";

const LIBRARY_PARAMS = { image_type: IMAGE_LIBRARY_TYPE.product };

/** Opened from the product picture on /menu. */
const ProductImageModal = ({ onExit }: ModalProps) => {
  const [{ product, parentId }] = useModalMeta() as [
    { product: Product; parentId: number },
    unknown,
  ];
  const { t } = useTranslation();
  const branch = useBranchId();
  const saveFile = useProductImageSave(product, parentId);
  const productName = getFieldByLang(product?.name) ?? "";

  return (
    <UploadImageWithLibraryModal
      onExit={onExit}
      onSave={([file]) => saveFile(file)}
      title={t("productImage.title")}
      subtitle={productName}
      currentImage={getMenuImageUrl(product?.image_cloudinary_id, branch)}
      libraryParams={LIBRARY_PARAMS}
      librarySuggestFor={productName}
      guidelines={PRODUCT_IMAGE_GUIDELINES}
    />
  );
};

export default ProductImageModal;
